// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postVideoRequest } from '../../services/VideoService';
import { Video, PostVideoRequest } from '../../types/Videos';

type Result = UseMutationResult<Video[], unknown, PostVideoRequest>;

function getVideoRequestErrorMessage(error: unknown): string {
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object') {
    const maybeMessage = (error as { message?: string | string[] }).message;
    if (Array.isArray(maybeMessage)) {
      return maybeMessage.join(', ');
    }
    if (typeof maybeMessage === 'string') {
      return maybeMessage;
    }
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'Failed to request video';
}

function usePostVideoRequest(successCb: (data: Video[]) => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postVideoRequest, {
    onSuccess: (data: Video[]) => {
      successCb(data);
      queryClient.invalidateQueries({ queryKey: ['videos'] });
      queryClient.invalidateQueries({ queryKey: ['videos-lazy'] });
      queryClient.invalidateQueries({ queryKey: ['videos-lazy-latest'] });
      queryClient.invalidateQueries({ queryKey: ['active-custom-vod-limit'] });
    },
    onError: (error: unknown) => {
      failureCb(getVideoRequestErrorMessage(error));
    },
  });
}

export default usePostVideoRequest;
